module.exports = __webpack_public_path__ + "img/1.bb030362.jpg";